export default __webpack_public_path__ + "static/media/docfile.a11f54a8.svg";